// You can write your custom Javascript here
var sizes = $('.sizes-order')
.text()
.split(',');

$('.js-filter-option.sizes').each(function() {
  var $this = $(this);
  var $listItem = $this.parent();
  var text = $this.data('filter');

  for (var i = 0; i < sizes.length; i++) {
    if (text.indexOf(sizes[i].toLowerCase()) >= 0) {
      $listItem.css('order', i);
    }
  }
});

/**
 * Add padding-top on mobile - intro
 *
 * @return {[type]}
 */
if ($(window).width() < 767) {
  const $intro = $('.intro');
  const $sectionVideo = $('.js-section-video');
  const $headerHeight = $('.header').outerHeight();

  $intro.css('padding-top', $headerHeight);
  $sectionVideo.css('margin-top', $headerHeight);
}

/**
 * Limiting birthday fields up to 2.
 *
 * @return {[type]}
 */
$('.js-newsletter-form input[type=text]').attr("maxlength", 2);

/**
 * Make the filters into accordion on mobile.
 *
 * @return {[type]}
 */
const $nav = $('.js-sidebar-nav');
const $shopAll = $nav.find('div[data-type="shop-all"]');
const $shopAllLink = $shopAll.find('.js-filter-text');
const $win = $(window);
const $size = $nav.find('.filter__option[data-type="sizes"]');

$size.find('ul').hide();
$shopAllLink.attr("href", "/collections/all");
$shopAllLink.removeClass('js-filter-text');


if ($win.width() < 767) {
  $shopAllLink.text('Filter & Sort');
  $shopAllLink.addClass('mobile-filter-icon');
  
  $shopAllLink.on('click', function(event) {
    event.preventDefault();
    const $this = $(this);

    $shopAll.toggleClass('is-expanded');

    $this.closest('.sidebar__nav').find('.filter__option').each(function(index) {
      const $this = $(this);

      if (index !== 0) {
        $this.slideToggle();
      }

      if ($win.width() <= 767) {
        $this.closest('.sidebar__nav').toggleClass('is-active');
      }
    })

    
    $this.closest('.sidebar__nav').find('.menu__item').slideToggle();
  })
}

/**
 * Handle Size filters on Desktop
 *
 * @return {[type]}
 */
if ($win.width() > 767) {
  const $size = $nav.find('.filter__option[data-type="sizes"]');
  const $colours = $nav.find('.filter__option[data-type="colours"]');  

  if ($size.find('ul').children().length == 0) {
    $size.hide();
  }
  
  if ($colours.find('ul').children().length == 0) {
    $colours.hide();
  }

  $size.find('.js-filter-text').on('click', function(event) {
    event.preventDefault();
    const $this = $(this);

    $this.closest('.filter__option').toggleClass('is-active');

    $this.parent().next().slideToggle(function() {
      if ($(this).is(':visible')) {
        $(this).css('display','flex')
      }
    })
  })
}